module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Shield-user-f532b4e429512f2bf231d310b5b1c58d.svg";